import { render } from "./RegistroVariosCodigos.vue?vue&type=template&id=6d80c9dd&scoped=true"
import script from "./RegistroVariosCodigos.vue?vue&type=script&lang=js"
export * from "./RegistroVariosCodigos.vue?vue&type=script&lang=js"

import "./RegistroVariosCodigos.vue?vue&type=style&index=0&id=6d80c9dd&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\allikamay\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d80c9dd"]])

export default __exports__